import React, { useContext, useState } from "react";
import closeIcon from "../../../assets/close_icon.svg";
import logoutIcon from "../../../assets/icon_logout.svg";
import logoutIconWhite from "../../../assets/icon_logout_white.svg"; // import the white version of the icon
import { UserContext } from "../../../context/UserContext.component";
import MenuButton from "../menuButton/MenuButton.component";
import { menuData } from "../../../data/MenuData";
import { Logout } from "../../../api/apiLogout";

export const MobileMenu = ({ show, setShow }) => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [activeParentMenuItem, setActiveParentMenuItem] = useState(null);
  const [isParentHovered, setIsParentHovered] = useState(false); // add state to track hover state of parent div

  const { dispatch } = useContext(UserContext);

  const handleLogout = async () => {
    await Logout(dispatch);
  };

  return (
    <nav
      className={`fixed top-0 w-[100%] h-[100vh] overflow-y-auto font-rubik bg-[#FFFFFF] flex flex-col animate__animated  animate__slideInRight items-end text-right md:hidden ${
        !show && "hidden"
      }`}
    >
      <img
        src={closeIcon}
        alt="close button"
        className=" cursor-pointer mt-5 mr-4"
        onClick={() => setShow(!show)}
      />

      <h2 className="pr-10 pt-6 text-[22px] font-bold">Menu</h2>

      {menuData.map((menuItem) => (
        <MenuButton
          key={menuItem.id}
          menuItem={menuItem}
          setActiveMenuItem={setActiveMenuItem} // Pass the callback function
          activeMenuItem={activeMenuItem} // Pass the active menu item id
          setActiveParentMenuItem={setActiveParentMenuItem} // Pass the callback function
          activeParentMenuItem={activeParentMenuItem} // Pass the active menu item id
          isMobile={true}
        />
      ))}

      <div
        className={`w-full border-t border-b py-5 pr-10 mt-9 flex justify-end items-center`}
        onClick={handleLogout}
        onMouseEnter={() => setIsParentHovered(true)}
        onMouseLeave={() => setIsParentHovered(false)}
      >
        <img
          src={isParentHovered ? logoutIconWhite : logoutIcon}
          alt="logout button"
          className="mr-2"
        />
        <p className={`font-semibold text-base`}>Logout</p>
      </div>
    </nav>
  );
};
